import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../services/api.service';
import { FileUpload } from 'primeng/fileupload';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-idex-bids',
  standalone: false,
  templateUrl: './idex-bids.component.html',
  styleUrl: './idex-bids.component.scss',
})
export class IdexBidsComponent implements OnInit {
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() schemeType: string;
  @Input() proposalName: any;
  @Input() id: any;
  @Input() format: any;
  @Input() proposalId: any;
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  uploadedUrl: any;
  apiUrl = environment.APIUrl;
  uploadedFileName: string = '';
  vendors: any;
  private subscriptions = new Subscription();
  userID: any;
  constructor(
    private messageService: MessageService,
    private apiService: ApiService
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }
  ngOnInit() {
    this.getData();
  }

  onUpload(event: any, vendor: any) {
    for (let file of event.files) {
      // Ideally, you'd get back uploaded file URLs from backend
      vendor.uploadedFiles.push({
        name: file.name,
        url: `https://your-backend/uploads/${vendor.name}/${file.name}`,
      });
    }
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
  setStatus(vendor: any, status: 'Qualified' | 'Disqualified') {
    vendor.vendor_status = status;
    const formData = new FormData();
    formData.append('vendor_status', vendor.vendor_status);

    const sub = this.apiService
      .putAPI(`/idex/upload/compliance/pds-pru/${vendor.id}/`, formData)
      .subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Vendor updated successfully',
          });
          this.getData(); // refresh the table
        },
        error: (err) => {},
      });
  }
  onSubmit() {}
  clearUpload(fileUpload: any) {
    this.uploadedFileName = null;
    // this.uploadedUrl = null;
    fileUpload.clear();
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 35 ? fileName.substring(0, 30) + '...' : fileName;
  }
  getData() {
    let url = `/idex/upload/compliance/pds-pru/?proposal_step=${this.id}&proposal_step__proposal=${this.proposalId}`;
    const sub = this.apiService.getAPI(url).subscribe((resp: any) => {
      this.vendors = resp.data.vendors.map((row: any) => {
        // map API "documents"
        row.documents =
          row.documents?.map((doc: any) => ({
            fileId: doc.document,
            fileName: doc.document.split('/').pop(),
          })) || [];
        return row;
      });
    });
    this.subscriptions.add(sub);
  }
}
